import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import { ReportsPage } from '../pages';

export const routes = (
  <Route
    path="/admin/reports"
    element={
      <PrivateRoute>
        <ReportsPage />
      </PrivateRoute>
    }
  />
);
